import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InfoIcon from '@mui/icons-material/Info';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HelpIcon from '@mui/icons-material/Help';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import RectangleOutlinedIcon from '@mui/icons-material/RectangleOutlined';
import RectangleIcon from '@mui/icons-material/Rectangle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import ReplayIcon from '@mui/icons-material/Replay';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import UndoIcon from '@mui/icons-material/Undo';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SearchIcon from '@mui/icons-material/Search';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import UploadIcon from '@mui/icons-material/Upload';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AddIcon from '@mui/icons-material/Add';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CloseIcon from '@mui/icons-material/Close';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

export const iconVariants = [
  {
    type: 'Home',
    outlined: <HomeOutlinedIcon fontSize="large" />,
    filled: <HomeIcon fontSize="large" />,
    label: 'Home',
  },
  {
    type: 'Information',
    outlined: <InfoOutlinedIcon fontSize="large" />,
    filled: <InfoIcon fontSize="large" />,
    label: 'Information',
  },
  {
    type: 'Help',
    outlined: <HelpOutlineIcon fontSize="large" />,
    filled: <HelpIcon fontSize="large" />,
    label: 'Help',
  },

  {
    type: 'Bookmark',
    outlined: <BookmarkBorderOutlinedIcon fontSize="large" />,
    filled: <BookmarkIcon fontSize="large" />,
    label: 'Bookmark',
  },
  {
    type: 'QnA',
    outlined: <ChatBubbleOutlineIcon fontSize="large" />,
    filled: <ChatBubbleIcon fontSize="large" />,
    label: 'QnA',
  },

  {
    type: 'Blank',
    outlined: <RectangleOutlinedIcon fontSize="large" />,
    filled: <RectangleIcon fontSize="large" />,
    label: 'Blank',
  },
  {
    type: 'Left Arrow',
    outlined: <ArrowBackOutlinedIcon fontSize="large" />,
    filled: <ArrowBackIcon fontSize="large" />,
    label: 'Left Arrow',
  },
  {
    type: 'Right Arrow',
    outlined: <ArrowForwardOutlinedIcon fontSize="large" />,
    filled: <ArrowForwardIcon fontSize="large" />,
    label: 'Right Arrow',
  },
  {
    type: 'Reset',
    outlined: <ReplayOutlinedIcon fontSize="large" />,
    filled: <ReplayIcon fontSize="large" />,
    label: 'Reset',
  },
  {
    type: 'Back',
    outlined: <UndoOutlinedIcon fontSize="large" />,
    filled: <UndoIcon fontSize="large" />,
    label: 'Back',
  },
  {
    type: 'Refresh',
    outlined: <RefreshOutlinedIcon fontSize="large" />,
    filled: <RefreshIcon fontSize="large" />,
    label: 'Refresh',
  },

  {
    type: 'Settings',
    outlined: <SettingsOutlinedIcon fontSize="large" />,
    filled: <SettingsIcon fontSize="large" />,
    label: 'Settings',
  },
  {
    type: 'Search',
    outlined: <SearchOutlinedIcon fontSize="large" />,
    filled: <SearchIcon fontSize="large" />,
    label: 'Search',
  },
  {
    type: 'Download',
    outlined: <DownloadOutlinedIcon fontSize="large" />,
    filled: <DownloadIcon fontSize="large" />,
    label: 'Download',
  },
  {
    type: 'Upload',
    outlined: <UploadOutlinedIcon fontSize="large" />,
    filled: <UploadIcon fontSize="large" />,
    label: 'Upload',
  },
  {
    type: 'Delete',
    outlined: <DeleteOutlineIcon fontSize="large" />,
    filled: <DeleteIcon fontSize="large" />,
    label: 'Delete',
  },
  {
    type: 'Edit',
    outlined: <EditOutlinedIcon fontSize="large" />,
    filled: <EditIcon fontSize="large" />,
    label: 'Edit',
  },
  {
    type: 'Add',
    outlined: <AddOutlinedIcon fontSize="large" />,
    filled: <AddIcon fontSize="large" />,
    label: 'Add',
  },
  {
    type: 'Close',
    outlined: <CloseOutlinedIcon fontSize="large" />,
    filled: <CloseIcon fontSize="large" />,
    label: 'Close',
  },
];
